import clsx from 'clsx';

import PaginationControl from '../PaginationControl';

import classes from '../../../styles/table.module.css';

function setTableHeaderClass(field, sortableFields, sortBy, isAscending) {
  const isSortByField = sortBy === field;
  const isSortable = isSortByField || sortableFields.includes(field);

  return clsx(
    isSortable && classes.isSortable,
    isSortByField && isAscending && classes.sortAscending,
    isSortByField && !isAscending && classes.sortDescending,
  );
}
function buildTableHeaders(
  displayHeaders,
  sortableFields,
  fields,
  sortBy,
  isAscending,
  sortRows,
) {
  return displayHeaders.map((header, headerIndex) => {
    const field = fields[headerIndex];
    const isSortable = sortBy === field || sortableFields.includes(field);
    const onClick = isSortable ? () => sortRows(field) : () => {};

    return (
      <th
        onClick={onClick}
        className={setTableHeaderClass(
          field,
          sortableFields,
          sortBy,
          isAscending,
        )}
        key={headerIndex}
      >
        {header}
      </th>
    );
  });
}

function buildRowFields(row, fields, buildCell) {
  return fields.map((field, fieldIndex) => {
    return buildCell(row, field, fieldIndex);
  });
}

function buildRows(dataRows, fields, buildCell) {
  return dataRows.map((row, rowIndex) => {
    return <tr key={rowIndex}>{buildRowFields(row, fields, buildCell)}</tr>;
  });
}

interface Props {
  displayHeaders: any[];
  sortableFields?: any[];
  sortBy: string;
  isAscending: boolean;
  sortRows?: () => any;
  dataRows: any[];
  fields: any[];
  buildCell: () => any;
  disablePagination: boolean;
  totalRows?: number;
  incrementPage: () => any;
  updateLimit: () => any;
  page?: number;
  limit?: number;
  // style represents the root style on this component
  style?: any;
  limitOptions?: number[];
}

const ListViewTable = ({
  displayHeaders,
  sortableFields = [],
  sortBy = '',
  isAscending,
  sortRows,
  dataRows,
  fields,
  buildCell,
  disablePagination = false,
  totalRows,
  incrementPage,
  updateLimit,
  page,
  limit,
  style,
  limitOptions,
}: Props) => {
  return (
    <div className={clsx(classes.mainPane, classes.listView)} style={style}>
      <table className={classes.sticky}>
        <thead>
          <tr>
            {buildTableHeaders(
              displayHeaders,
              sortableFields,
              fields,
              sortBy,
              isAscending,
              sortRows,
            )}
          </tr>
        </thead>
        <tbody className={classes.hidden}>
          {buildRows(dataRows, fields, buildCell)}
        </tbody>
      </table>
      <table>
        <thead className={classes.hidden}>
          <tr>
            {buildTableHeaders(
              displayHeaders,
              sortableFields,
              fields,
              sortBy,
              isAscending,
              sortRows,
            )}
          </tr>
        </thead>
        <tbody>{buildRows(dataRows, fields, buildCell)}</tbody>
      </table>
      <table className={classes.paginationContainer}>
        <tbody>
          {!disablePagination && (
            <tr>
              <td
                className={classes.loadMoreWrapper}
                colSpan={displayHeaders.length}
              >
                <PaginationControl
                  incrementPage={incrementPage}
                  updateLimit={updateLimit}
                  page={page}
                  limit={limit}
                  total={totalRows}
                  limitOptions={limitOptions}
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListViewTable;
